export const OPEN_SHARE_SERVER = 'authenticated' as const;
export const PROJECT_ROLE_SHARE_SERVER = 'projectRole' as const;
